<sis-button [link]="true" (clicked)="clicked.emit()" [disabled]="disabled" [dataCy]="dataCy" [id]="id" [class.dashed-add-box]="dashBox">
  <sis-icon [icon]="disabled ? 'ring-plus' : 'ring-plus-fill'" color="light"></sis-icon>{{label}}
</sis-button>
